import { post } from 'root/widgets/pg-login/services/http';
import { JWTData } from 'root/widgets/pg-login/types';

export const createLegacySession = (data: JWTData, originatedFrom?: string) =>
  post('/user/loginWithJWT', data, originatedFrom ? { 'x-hui-origin-segment': originatedFrom } : undefined);
